import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-doctors-next',
  templateUrl: './doctors-next.component.html',
  styleUrls: ['./doctors-next.component.css', './style/index.css'],
})
export class DoctorsNextComponent extends BaseLoginComponent implements OnInit {
  titleMaps() {
    return {
      'forgot-password': 'パスワードを忘れた方 | Doctors Next™',
      'password-reset-send':
        'リセット用URLをメールで送信しました | Doctors Next™',
      login: 'ログイン | Doctors Next™',
      register: '新規登録 | Doctors Next™',
      'register-resend': '',
    };
  }
}
